// Approval-workflow (ChangeRequest) constants — see
// api_contract/api-contract-approval-workflow.md.
// One controller (`v1/ChangeRequest`) serves all three menus.

export const CHANGE_REQUEST_ENDPOINTS = {
  REVIEWAL_LIST: '/v1/ChangeRequest/GetReviewalList',
  APPROVAL_LIST: '/v1/ChangeRequest/GetApprovalList',
  MY_LIST: '/v1/ChangeRequest/GetMyList',
  // Actions are [FromForm]: { requestId, notes } -> 201 Created, empty body.
  REVIEW: '/v1/ChangeRequest/Review',
  REJECT_REVIEWAL: '/v1/ChangeRequest/RejectReviewal',
  APPROVE: '/v1/ChangeRequest/Approve',
  REJECT_APPROVAL: '/v1/ChangeRequest/RejectApproval',
  CANCEL: '/v1/ChangeRequest/Cancel',
};

// StatusRequest enum (src/01.Base/Common/Enums/StatusRequest.cs).
// Serialized by the API as the string name (e.g. "AwaitingReview"), not the
// numeric enum value.
export const CHANGE_REQUEST_STATUS = {
  DRAFT: 'Draft',
  AWAITING_REVIEW: 'AwaitingReview',
  AWAITING_APPROVE: 'AwaitingApprove',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  CANCELED: 'Canceled',
};

const STATUS_LABELS = {
  Draft: 'Draft',
  AwaitingReview: 'Awaiting Review',
  AwaitingApprove: 'Awaiting Approve',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Canceled: 'Canceled',
};

export const statusLabel = status => STATUS_LABELS[status] ?? 'Unknown';

export const statusBadgeClass = status => {
  switch (status) {
    case CHANGE_REQUEST_STATUS.APPROVED:
      return 'badge bg-success-subtle text-success';
    case CHANGE_REQUEST_STATUS.REJECTED:
      return 'badge bg-danger-subtle text-danger';
    case CHANGE_REQUEST_STATUS.CANCELED:
      return 'badge bg-secondary-subtle text-secondary';
    case CHANGE_REQUEST_STATUS.AWAITING_REVIEW:
      return 'badge bg-warning-subtle text-warning';
    case CHANGE_REQUEST_STATUS.AWAITING_APPROVE:
      return 'badge bg-info-subtle text-info';
    case CHANGE_REQUEST_STATUS.DRAFT:
      return 'badge bg-light text-dark';
    default:
      return 'badge bg-light text-dark';
  }
};
